import breakpoints from "../breakpoints.js";

const initAnchors = (scope = document) => {
	const $anchorLinks = scope.querySelectorAll('.js-anchor');
	$anchorLinks.forEach($anchorLink => {
		$anchorLink.addEventListener('click', e => {
			e.preventDefault();
			let targetId = $anchorLink.getAttribute('href');
			if (targetId) {
				let $target = document.querySelector(targetId);
				if ($target) {
					let isSm = window.innerWidth <= breakpoints['sm-max'];
					window.scrollTo({
						top: $target.getBoundingClientRect().top + window.pageYOffset - (isSm ? 20 : 200),
						behavior: 'smooth',
					});
				}
			}
		});
	});
}

export default initAnchors;